import { ReportTemplate } from '../../../types/apiModels'
import { apiClient } from '../client'
import endpoints from '../endpoints'
import { unwrapCollection } from '../normalize'

export default async function getReportTemplates({
  signal,
}: {
  signal?: AbortSignal
}): Promise<ReportTemplate[]> {
  const response = await apiClient.get(endpoints.v2.reports.templates, { signal })
  return unwrapCollection<ReportTemplate>(response)
}
